import type { Video, VideoCategory } from "@/types/video";

export const categories: VideoCategory[] = [
  {
    slug: "entertainment",
    name: "娱乐",
    icon: "ri-movie-2-line",
    description: "舞台、综艺、搞笑与明星现场，快乐从这里开始。",
  },
  {
    slug: "life",
    name: "生活",
    icon: "ri-plant-line",
    description: "收纳、居家与日常小技巧，把平凡日子过出质感。",
  },
  {
    slug: "fun",
    name: "趣味",
    icon: "ri-emotion-happy-line",
    description: "萌宠、魔术与整蛊合集，笑点密集绝不重样。",
  },
  {
    slug: "food",
    name: "美食",
    icon: "ri-restaurant-2-line",
    description: "街头小吃、家常菜与甜品烘焙，一起大饱口福。",
  },
  {
    slug: "travel",
    name: "旅行",
    icon: "ri-flight-takeoff-line",
    description: "海岛、山野与城市夜色，带你云游四方。",
  },
  {
    slug: "tech",
    name: "科技",
    icon: "ri-cpu-line",
    description: "数码新品、编程入门与未来科技，先睹为快。",
  },
  {
    slug: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    description: "弹唱、现场与纯音乐，用旋律治愈你的耳朵。",
  },
  {
    slug: "sports",
    name: "运动",
    icon: "ri-basketball-line",
    description: "篮球、跑步与瑜伽，燃动每一滴汗水。",
  },
];

export const videos: Video[] = [
  {
    id: "v1",
    title: "舞台高光时刻：全场沸腾的年度盛典演出",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20concert%20stage%20with%20warm%20orange%20spotlights%2C%20silhouettes%20of%20performers%20and%20a%20cheering%20crowd%2C%20dynamic%20energy%2C%20cinematic%20bokeh%20lights%2C%20professional%20event%20photography%2C%20high%20detail%2C%20dramatic%20atmosphere&width=640&height=360&seq=td-v01&orientation=landscape",
    duration: 342,
    plays: 1280000,
    publishDate: "2026-09-28",
    category: "entertainment",
    author: "糖豆娱乐",
    description:
      "年度盛典的舞台高光浓缩在这支短片里。从开场灯光秀到压轴大合唱，每一个镜头都记录着现场观众此起彼伏的欢呼。带你重温那一晚最令人热血沸腾的三分钟。",
    featured: true,
  },
  {
    id: "v2",
    title: "办公室爆笑日常：同事间的那些神操作",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20creative%20office%20with%20playful%20coworkers%20laughing%2C%20colorful%20sticky%20notes%20on%20glass%20wall%2C%20warm%20afternoon%20sunlight%2C%20candid%20lifestyle%20photography%2C%20cheerful%20atmosphere%2C%20clean%20composition&width=640&height=360&seq=td-v02&orientation=landscape",
    duration: 268,
    plays: 860000,
    publishDate: "2026-09-20",
    category: "entertainment",
    author: "糖豆娱乐",
    description:
      "把职场里那些让人哭笑不得的瞬间拍成了喜剧。打印机卡纸、会议室抢座、群里已读不回……总有一个片段让你觉得‘这不就是我吗’。笑着笑着就共情了。",
  },
  {
    id: "v3",
    title: "明星面对面：聊聊镜头背后的真实故事",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20intimate%20interview%20set%20with%20two%20chairs%2C%20soft%20studio%20lighting%2C%20microphone%20and%20subtle%20orange%20backdrop%2C%20professional%20talk%20show%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography&width=640&height=360&seq=td-v03&orientation=landscape",
    duration: 726,
    plays: 540000,
    publishDate: "2026-09-12",
    category: "entertainment",
    author: "糖豆娱乐",
    description:
      "褪去聚光灯，嘉宾聊起了入行初期的迷茫与坚持。没有台本、没有提词器，只有一次坦诚的对话。想听听镜头背后的真实故事吗？",
  },
  {
    id: "v4",
    title: "晨间仪式感：十分钟打造元气满满的一天",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20minimal%20morning%20scene%2C%20steaming%20cup%20of%20coffee%20on%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20linen%20textures%2C%20calm%20warm%20tones%2C%20lifestyle%20photography%2C%20serene%20atmosphere&width=640&height=360&seq=td-v04&orientation=landscape",
    duration: 156,
    plays: 430000,
    publishDate: "2026-09-30",
    category: "life",
    author: "生活研究所",
    description:
      "早起十分钟，就能让一整天都不一样。从一杯手冲咖啡到简单的拉伸，这套晨间流程不需要昂贵装备，却能把生活的节奏重新握在自己手里。",
  },
  {
    id: "v5",
    title: "小户型收纳术：让家瞬间大两倍",
    cover:
      "https://readdy.ai/api/search-image?query=Tidy%20compact%20apartment%20interior%20with%20clever%20storage%20boxes%2C%20neatly%20folded%20clothes%2C%20bright%20airy%20space%2C%20soft%20daylight%2C%20organized%20calm%20aesthetic%2C%20interior%20lifestyle%20photography&width=640&height=360&seq=td-v05&orientation=landscape",
    duration: 402,
    plays: 760000,
    publishDate: "2026-09-18",
    category: "life",
    author: "生活研究所",
    description:
      "不到五十平的出租屋，也能拥有清爽的动线。视频整理了五个最实用的收纳思路：垂直利用、分类归位、藏露结合，照着做你会发现家里凭空多出一整面墙的空间。",
  },
  {
    id: "v6",
    title: "阳台变花园：新手也能养活的绿植清单",
    cover:
      "https://readdy.ai/api/search-image?query=Sunny%20balcony%20full%20of%20lush%20green%20potted%20plants%2C%20terracotta%20pots%2C%20morning%20light%20and%20shadows%2C%20fresh%20natural%20atmosphere%2C%20gardening%20lifestyle%20photography%2C%20vibrant%20greenery&width=640&height=360&seq=td-v06&orientation=landscape",
    duration: 224,
    plays: 290000,
    publishDate: "2026-09-08",
    category: "life",
    author: "生活研究所",
    description:
      "总是把绿植养死？那是没选对品种。这份清单里的植物全都耐阴好养、几乎不挑人，配上浇水和光照的小贴士，让你的阳台一个季度就绿意盎然。",
  },
  {
    id: "v7",
    title: "猫咪的一百种撒娇方式，可爱到犯规",
    cover:
      "https://readdy.ai/api/search-image?query=Adorable%20fluffy%20cat%20rubbing%20against%20owner&width=640&height=360&seq=td-v07&orientation=landscape's hand%2C soft bright living room background%2C warm natural light%2C cute expressive eyes%2C pet lifestyle photography%2C cheerful mood",
    duration: 92,
    plays: 2140000,
    publishDate: "2026-10-02",
    category: "fun",
    author: "趣味星球",
    description:
      "从踩奶、贴贴到用头蹭你，猫咪的撒娇方式比你想的丰富得多。这支合集记录了主子们最治愈的瞬间，配上一句都没说却全懂了的字幕，看完心情瞬间变好。",
    featured: true,
  },
  {
    id: "v8",
    title: "街头魔术秀：路人惊呆的瞬间",
    cover:
      "https://readdy.ai/api/search-image?query=Street%20magician%20performing%20a%20card%20trick%20for%20surprised%20pedestrians%2C%20urban%20daylight%2C%20candid%20reactions%2C%20dynamic%20composition%2C%20vibrant%20city%20atmosphere%2C%20documentary%20style%20photography&width=640&height=360&seq=td-v08&orientation=landscape",
    duration: 318,
    plays: 1320000,
    publishDate: "2026-09-25",
    category: "fun",
    author: "趣味星球",
    description:
      "一枚硬币在指尖凭空消失，又出现在观众的口袋里。这场街头魔术全程一镜到底，没有剪辑特效，只靠手法和气氛，让路过的人纷纷停下脚步。",
  },
  {
    id: "v9",
    title: "极限整蛊合集：笑到停不下来的名场面",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20friends%20pranking%20each%20other%20in%20a%20garden%2C%20joyful%20shocked%20expressions%2C%20bright%20sunny%20day%2C%20vibrant%20green%20background%2C%20candid%20fun%20photography%2C%20lively%20atmosphere&width=640&height=360&seq=td-v09&orientation=landscape",
    duration: 276,
    plays: 980000,
    publishDate: "2026-09-15",
    category: "fun",
    author: "趣味星球",
    description:
      "都是无伤大雅的善意玩笑，主角们的反应却一个比一个真实。看之前提醒一句：请勿在饭后观看，容易笑到肚子疼。",
  },
  {
    id: "v10",
    title: "夜市必吃榜：藏在巷子里的地道小吃",
    cover:
      "https://readdy.ai/api/search-image?query=Busy%20night%20market%20food%20street%20with%20glowing%20lanterns%2C%20sizzling%20street%20food%20stalls%2C%20warm%20orange%20lights%2C%20steam%20rising%2C%20lively%20evening%20atmosphere%2C%20food%20documentary%20photography&width=640&height=360&seq=td-v10&orientation=landscape",
    duration: 468,
    plays: 1120000,
    publishDate: "2026-10-01",
    category: "food",
    author: "美食小分队",
    description:
      "跟着本地人走，才不会踩雷。这一期我们钻进老城区的巷子，从现炸酥肉到手工糖水，把最地道的一口都尝了个遍。附带详细摊位位置，出行直接照着吃。",
    featured: true,
  },
  {
    id: "v11",
    title: "零失败甜品：在家复刻网红蛋糕",
    cover:
      "https://readdy.ai/api/search-image?query=Homemade%20layered%20cream%20cake%20on%20a%20marble%20counter%2C%20fresh%20berries%20and%20frosting%2C%20soft%20diffused%20daylight%2C%20clean%20bright%20kitchen%2C%20dessert%20food%20photography%2C%20appetizing%20detail&width=640&height=360&seq=td-v11&orientation=landscape",
    duration: 354,
    plays: 690000,
    publishDate: "2026-09-22",
    category: "food",
    author: "美食小分队",
    description:
      "没有烤箱也能做。这款网红蛋糕只用到三种基础材料，视频里把每一步的失败点都提前标注了出来，跟着做第一次就能成功，端上桌特别有面子。",
  },
  {
    id: "v12",
    title: "一锅搞定：懒人也能做的快手家常菜",
    cover:
      "https://readdy.ai/api/search-image?query=One%20pot%20home%20style%20dish%20steaming%20on%20a%20stove%2C%20fresh%20vegetables%20and%20meat%2C%20cozy%20kitchen%20background%2C%20warm%20inviting%20light%2C%20home%20cooking%20photography%2C%20rustic%20appetizing%20mood&width=640&height=360&seq=td-v12&orientation=landscape",
    duration: 198,
    plays: 410000,
    publishDate: "2026-09-05",
    category: "food",
    author: "美食小分队",
    description:
      "下班太累不想做饭？这口锅从下料到出锅只要十五分钟，洗刷也只有一个锅。视频给了三种口味搭配，米饭面条都能配，忙到深夜也能吃上一顿热乎的。",
  },
  {
    id: "v13",
    title: "海岛慢生活：浮潜看珊瑚的治愈之旅",
    cover:
      "https://readdy.ai/api/search-image?query=Crystal%20clear%20turquoise%20sea%20with%20coral%20reef%20snorkeling%2C%20sunny%20tropical%20island%2C%20underwater%20light%20rays%2C%20vibrant%20travel%20scene%2C%20serene%20peaceful%20atmosphere%2C%20high%20clarity%20photography&width=640&height=360&seq=td-v13&orientation=landscape",
    duration: 512,
    plays: 870000,
    publishDate: "2026-09-27",
    category: "travel",
    author: "旅行手账",
    description:
      "把手机调成静音，跟着镜头潜入碧蓝的海水里。成群的小鱼掠过珊瑚，阳光在水面下碎成光斑。这支短片没有解说，只有海浪声，适合在疲惫的时候循环播放。",
  },
  {
    id: "v14",
    title: "徒步山野：云海日出的震撼瞬间",
    cover:
      "https://readdy.ai/api/search-image?query=Hiker%20overlooking%20a%20sea%20of%20clouds%20at%20sunrise%20on%20a%20mountain%20peak%2C%20golden%20light%2C%20vast%20layered%20ridges%2C%20epic%20landscape%20photography%2C%20dramatic%20warm%20tones%2C%20breathtaking%20view&width=640&height=360&seq=td-v14&orientation=landscape",
    duration: 604,
    plays: 630000,
    publishDate: "2026-09-19",
    category: "travel",
    author: "旅行手账",
    description:
      "凌晨四点出发，摸黑爬了三个小时，只为等那一刻。当云海被第一缕阳光染成金红色，所有的疲惫都值了。视频附上完整路线与装备清单，新手也能安全打卡。",
  },
  {
    id: "v15",
    title: "城市夜游指南：灯火里的烟火气",
    cover:
      "https://readdy.ai/api/search-image?query=City%20skyline%20at%20night%20with%20warm%20street%20lights%20and%20reflections%20on%20water%2C%20bustling%20urban%20evening%2C%20glowing%20windows%2C%20cinematic%20night%20photography%2C%20vibrant%20metropolitan%20atmosphere&width=640&height=360&seq=td-v15&orientation=landscape",
    duration: 386,
    plays: 520000,
    publishDate: "2026-09-10",
    category: "travel",
    author: "旅行手账",
    description:
      "白天的城市千篇一律，夜晚才露出真实的性情。这条路线串起了老码头、河边步道和深夜食街，边走边吃两小时刚好。收藏起来，下次出差也能用上。",
  },
  {
    id: "v16",
    title: "新品上手：这些黑科技小玩意太惊艳",
    cover:
      "https://readdy.ai/api/search-image?query=Sleek%20modern%20tech%20gadgets%20arranged%20on%20a%20clean%20desk%2C%20subtle%20neon%20accents%2C%20soft%20studio%20lighting%2C%20minimal%20futuristic%20aesthetic%2C%20product%20photography%2C%20sharp%20detail&width=640&height=360&seq=td-v16&orientation=landscape",
    duration: 432,
    plays: 1040000,
    publishDate: "2026-10-03",
    category: "tech",
    author: "科技前哨",
    description:
      "一次性上手五款近期讨论度很高的小玩意：能自动调光的台灯、口袋尺寸的投影仪、还有一块会变色的键盘。哪些值得买、哪些是噱头，视频里说得很清楚。",
    featured: true,
  },
  {
    id: "v17",
    title: "零基础学编程：三分钟看懂代码逻辑",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20code%20on%20a%20laptop%20screen%20in%20a%20dim%20cozy%20room%2C%20soft%20desk%20lamp%20glow%2C%20minimal%20desk%20setup%2C%20programmer%20workspace%2C%20modern%20clean%20aesthetic%2C%20focused%20atmosphere&width=640&height=360&seq=td-v17&orientation=landscape",
    duration: 174,
    plays: 720000,
    publishDate: "2026-09-24",
    category: "tech",
    author: "科技前哨",
    description:
      "看不懂满屏的英文和符号？其实代码的本质就是一句句给电脑的指令。用生活里的例子把变量、循环和判断讲清楚，三分钟后你也能读懂一段简单的程序。",
  },
  {
    id: "v18",
    title: "机器人实验室：未来生活离我们有多近",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20robotics%20laboratory%20with%20a%20friendly%20humanoid%20robot%2C%20clean%20white%20high%20tech%20interior%2C%20soft%20blue%20white%20lighting%2C%20futuristic%20lab%20equipment%2C%20scientific%20documentary%20photography&width=640&height=360&seq=td-v18&orientation=landscape",
    duration: 548,
    plays: 480000,
    publishDate: "2026-09-13",
    category: "tech",
    author: "科技前哨",
    description:
      "走进实验室，看机器人如何学会端水、开门，甚至察言观色。工程师们聊了聊它的‘成长’过程，也坦率地谈到了目前还做不到的事情。未来也许比想象中更近。",
  },
  {
    id: "v19",
    title: "吉他弹唱：适合深夜循环的温柔旋律",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20acoustic%20guitar%20leaning%20by%20a%20window%20with%20fairy%20lights%2C%20cozy%20evening%20room%2C%20soft%20amber%20glow%2C%20intimate%20music%20atmosphere%2C%20lifestyle%20photography%2C%20calm%20mood&width=640&height=360&seq=td-v19&orientation=landscape",
    duration: 246,
    plays: 910000,
    publishDate: "2026-09-29",
    category: "music",
    author: "音乐盒子",
    description:
      "一把木吉他，一盏小灯，一段不需要歌词的旋律。这首弹唱是很多人私藏的睡前歌单，视频里还放慢了前奏部分，喜欢的话可以跟着一起练。",
  },
  {
    id: "v20",
    title: "现场live：万人合唱的热血时刻",
    cover:
      "https://readdy.ai/api/search-image?query=Massive%20concert%20crowd%20with%20lights%20and%20confetti%2C%20silhouettes%20raising%20hands%2C%20powerful%20stage%20lighting%2C%20energetic%20live%20music%20scene%2C%20cinematic%20wide%20shot%2C%20electric%20atmosphere&width=640&height=360&seq=td-v20&orientation=landscape",
    duration: 664,
    plays: 1360000,
    publishDate: "2026-09-21",
    category: "music",
    author: "音乐盒子",
    description:
      "当熟悉的副歌响起，全场几万人一起开口的那一刻，鸡皮疙瘩瞬间起来了。这支现场剪辑保留了完整的合唱段落，建议戴上耳机、开到最大声感受。",
    featured: true,
  },
  {
    id: "v21",
    title: "钢琴即兴：一段治愈心灵的清晨曲",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20piano%20by%20a%20large%20sunlit%20window%20with%20sheer%20curtains%2C%20soft%20morning%20light%2C%20elegant%20minimal%20room%2C%20peaceful%20refined%20atmosphere%2C%20artistic%20interior%20photography&width=640&height=360&seq=td-v21&orientation=landscape",
    duration: 288,
    plays: 380000,
    publishDate: "2026-09-06",
    category: "music",
    author: "音乐盒子",
    description:
      "没有乐谱、没有排练，就是清晨随手弹出的一段即兴。音符像阳光一样慢慢铺开，适合配着早餐或者读书时当作背景音，让心安静下来。",
  },
  {
    id: "v22",
    title: "街头篮球：燃到爆的绝杀时刻",
    cover:
      "https://readdy.ai/api/search-image?query=Street%20basketball%20court%20action%2C%20player%20jumping%20for%20a%20shot%2C%20urban%20outdoor%20setting%20at%20golden%20hour%2C%20dynamic%20motion%2C%20energetic%20sports%20photography%2C%20vibrant%20athletic%20atmosphere&width=640&height=360&seq=td-v22&orientation=landscape",
    duration: 224,
    plays: 1180000,
    publishDate: "2026-10-04",
    category: "sports",
    author: "运动日记",
    description:
      "比分咬到最后十秒，一记压哨三分直接点燃全场。这段镜头反复看了好多遍，那个出手的弧线实在太美了。热爱篮球的你不容错过。",
    featured: true,
  },
  {
    id: "v23",
    title: "晨跑路线推荐：用脚步唤醒一座城",
    cover:
      "https://readdy.ai/api/search-image?query=Runner%20jogging%20along%20a%20scenic%20riverside%20path%20at%20sunrise%2C%20soft%20golden%20light%2C%20green%20trees%20and%20calm%20water%2C%20healthy%20active%20lifestyle%2C%20fresh%20morning%20atmosphere%2C%20sport%20photography&width=640&height=360&seq=td-v23&orientation=landscape",
    duration: 192,
    plays: 350000,
    publishDate: "2026-09-16",
    category: "sports",
    author: "运动日记",
    description:
      "五公里的黄金路线，沿途有河景、绿荫和一段几乎没有车的小路。视频标注了补给点和最佳起跑时间，无论新手还是老手都能找到适合自己的节奏。",
  },
  {
    id: "v24",
    title: "十分钟瑜伽：久坐党必学的舒展动作",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20yoga%20studio%20with%20wooden%20floor%20and%20soft%20natural%20light%2C%20yoga%20mat%2C%20minimal%20warm%20interior%2C%20serene%20wellness%20atmosphere%2C%20peaceful%20lifestyle%20photography%2C%20soothing%20mood&width=640&height=360&seq=td-v24&orientation=landscape",
    duration: 624,
    plays: 560000,
    publishDate: "2026-09-09",
    category: "sports",
    author: "运动日记",
    description:
      "一坐就是一整天，肩颈腰背都在抗议。这组动作专为久坐人群设计，不需要任何器材，午休或睡前十分钟，跟着做完整个人都松下来了。",
  },
  {
    id: "v25",
    title: "综艺花絮：录制现场的意外笑场",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20lively%20TV%20variety%20show%20studio%20with%20colorful%20lights%20and%20laughing%20crew%20members%2C%20warm%20festive%20atmosphere%2C%20professional%20event%20photography%2C%20candid%20moment&width=640&height=360&seq=td-v25&orientation=landscape",
    duration: 312,
    plays: 620000,
    publishDate: "2026-09-14",
    category: "entertainment",
    author: "糖豆娱乐",
    description:
      "摄像机没停，笑场就没停。这支花絮记录了主持人和嘉宾在正式录制间隙的真实互动，比正片还好笑，也让人看到一档节目背后的轻松一面。",
  },
  {
    id: "v26",
    title: "街头采访：路人的神回复合集",
    cover:
      "https://readdy.ai/api/search-image?query=Street%20interview%20scene%20in%20a%20sunny%20city%20square%20with%20a%20young%20reporter%20holding%20a%20microphone%20talking%20to%20smiling%20pedestrians%2C%20bright%20daylight%2C%20documentary%20lifestyle%20photography&width=640&height=360&seq=td-v26&orientation=landscape",
    duration: 248,
    plays: 540000,
    publishDate: "2026-09-07",
    category: "entertainment",
    author: "糖豆娱乐",
    description:
      "同一个问题问一百个人，答案能有多离谱？这期街头采访收集了最出人意料的回答，从一本正经到脑洞大开，弹幕全程都在笑。",
  },
  {
    id: "v27",
    title: "厨房改造：五平米也能做出高级感",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20renovated%20small%20kitchen%20with%20warm%20wood%20cabinets%20and%20clean%20countertop%2C%20soft%20daylight%2C%20minimal%20cozy%20interior%20design%2C%20tidy%20composition%2C%20warm%20inviting%20tones&width=640&height=360&seq=td-v27&orientation=landscape",
    duration: 386,
    plays: 420000,
    publishDate: "2026-09-26",
    category: "life",
    author: "生活研究所",
    description:
      "五平米的老厨房，经过动线重排和收纳升级，也能拥有料理台与充足操作空间。视频给出了预算清单和改造前后对比，租房党也能照着做。",
  },
  {
    id: "v28",
    title: "旧物新生：把闲置改成实用好物",
    cover:
      "https://readdy.ai/api/search-image?query=DIY%20upcycling%20project%20desk%20with%20recycled%20items%20turned%20into%20useful%20decor%2C%20wooden%20table%2C%20natural%20light%2C%20creative%20handmade%20craft%20lifestyle%20photography%2C%20warm%20tones&width=640&height=360&seq=td-v28&orientation=landscape",
    duration: 256,
    plays: 310000,
    publishDate: "2026-09-11",
    category: "life",
    author: "生活研究所",
    description:
      "旧衣服、空玻璃瓶、纸箱，别急着扔。这支短片分享了几个零成本的改造思路，把闲置变成家里的小亮点，环保又有成就感。",
  },
  {
    id: "v29",
    title: "狗狗运动会：犯规也犯规得很可爱",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20golden%20retriever%20dogs%20running%20in%20a%20sunny%20green%20park%2C%20joyful%20motion%2C%20bright%20cheerful%20outdoor%20scene%2C%20pet%20lifestyle%20photography%2C%20vibrant%20happy%20atmosphere&width=640&height=360&seq=td-v29&orientation=landscape",
    duration: 168,
    plays: 890000,
    publishDate: "2026-09-23",
    category: "fun",
    author: "趣味星球",
    description:
      "狗狗运动会现场，选手们用实际行动证明：认真可以，但可爱更重要。从抢跑、撞栏到临门一脚的即兴发挥，每一帧都让人忍不住笑出声。",
  },
  {
    id: "v30",
    title: "搞笑配音合集：给生活加一句旁白",
    cover:
      "https://readdy.ai/api/search-image?query=Fun%20cozy%20studio%20desk%20with%20headphones%20and%20a%20microphone%20for%20voiceover%20recording%2C%20warm%20lamp%20light%2C%20playful%20casual%20setup%2C%20creative%20content%20creator%20workspace%20photography&width=640&height=360&seq=td-v30&orientation=landscape",
    duration: 204,
    plays: 470000,
    publishDate: "2026-09-04",
    category: "fun",
    author: "趣味星球",
    description:
      "给生活里的平凡瞬间配上一句吐槽旁白，整段视频立刻有了灵魂。这期合集收纳了网友最爱的配音片段，通勤路上听刚刚好。",
  },
  {
    id: "v31",
    title: "早餐不重样：一周快手早餐计划",
    cover:
      "https://readdy.ai/api/search-image?query=Variety%20of%20healthy%20homemade%20breakfast%20dishes%20on%20a%20bright%20table%20with%20fruit%20and%20eggs%2C%20top%20down%20view%2C%20soft%20morning%20light%2C%20cheerful%20food%20photography%2C%20fresh%20appetizing%20colors&width=640&height=360&seq=td-v31&orientation=landscape",
    duration: 342,
    plays: 560000,
    publishDate: "2026-09-17",
    category: "food",
    author: "美食小分队",
    description:
      "不吃外卖的一周，从早餐开始省下来。视频准备了七天不重样的快手早餐计划，全部控制在十五分钟内，配方和采购清单都整理好了。",
  },
  {
    id: "v32",
    title: "探店日记：藏在写字楼里的宝藏小馆",
    cover:
      "https://readdy.ai/api/search-image?query=Hidden%20cozy%20small%20restaurant%20interior%20with%20warm%20hanging%20lights%20and%20wooden%20tables%2C%20inviting%20local%20eatery%2C%20evening%20ambiance%2C%20food%20documentary%20photography%2C%20warm%20tones&width=640&height=360&seq=td-v32&orientation=landscape",
    duration: 428,
    plays: 380000,
    publishDate: "2026-09-03",
    category: "food",
    author: "美食小分队",
    description:
      "写字楼之间竟藏着这样一家小店。没有招牌、位置难找，却靠着一道招牌菜拴住了整栋楼的上班族。跟着镜头一起探店，顺便抄一份点单攻略。",
  },
  {
    id: "v33",
    title: "高铁两小时：周末就能去的周边小城",
    cover:
      "https://readdy.ai/api/search-image?query=Charming%20small%20old%20town%20street%20with%20tiled%20roofs%20and%20warm%20afternoon%20light%2C%20weekend%20travel%20destination%2C%20peaceful%20atmosphere%2C%20travel%20lifestyle%20photography%2C%20inviting%20mood&width=640&height=360&seq=td-v33&orientation=landscape",
    duration: 486,
    plays: 450000,
    publishDate: "2026-09-26",
    category: "travel",
    author: "旅行手账",
    description:
      "不用请假、不用赶飞机，高铁两小时就能抵达一座安静的小城。这条周末路线包含了老城漫步、特色小吃和一处绝佳拍照点，说走就走。",
  },
  {
    id: "v34",
    title: "露营初体验：装备到篝火的完整记录",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20camping%20tent%20by%20a%20lake%20at%20dusk%20with%20a%20warm%20campfire%2C%20starry%20sky%20beginning%20to%20appear%2C%20outdoor%20adventure%20scene%2C%20cinematic%20travel%20photography%2C%20warm%20glow&width=640&height=360&seq=td-v34&orientation=landscape",
    duration: 522,
    plays: 340000,
    publishDate: "2026-09-02",
    category: "travel",
    author: "旅行手账",
    description:
      "第一次露营从选址、搭帐篷到生火做饭，全程记录了下来。既有踩坑也有惊喜，视频最后附上了新手装备清单，想尝试的朋友可以少走弯路。",
  },
  {
    id: "v35",
    title: "AI工具实测：十分钟做完一周的活",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20a%20clean%20desk%20showing%20a%20colorful%20AI%20dashboard%20interface%2C%20soft%20ambient%20lighting%2C%20minimal%20tech%20workspace%2C%20futuristic%20productivity%20vibe%2C%20sharp%20detail&width=640&height=360&seq=td-v35&orientation=landscape",
    duration: 396,
    plays: 780000,
    publishDate: "2026-09-22",
    category: "tech",
    author: "科技前哨",
    description:
      "把重复又耗时的工作交给工具，一周的琐事十分钟就能理清。这期实测了几款热门AI工具，讲清楚了它们真正好用的场景和局限。",
  },
  {
    id: "v36",
    title: "桌搭分享：一千元打造极简工作台",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20aesthetic%20desktop%20setup%20with%20monitor%2C%20keyboard%2C%20small%20plant%20and%20warm%20lamp%2C%20tidy%20cozy%20room%2C%20soft%20light%2C%20modern%20desk%20setup%20photography%2C%20clean%20composition&width=640&height=360&seq=td-v36&orientation=landscape",
    duration: 288,
    plays: 520000,
    publishDate: "2026-09-01",
    category: "tech",
    author: "科技前哨",
    description:
      "不用花大价钱，也能拥有干净利落的工作台。视频从灯光、走线到小物收纳逐项拆解，用不到一千元完成了整个改造，拍照和办公都更舒服了。",
  },
  {
    id: "v37",
    title: "民谣翻唱：把喜欢的老歌唱给你听",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20acoustic%20folk%20music%20scene%20with%20a%20singer%20playing%20guitar%20under%20soft%20string%20lights%20at%20home%2C%20intimate%20cozy%20atmosphere%2C%20amber%20glow%2C%20lifestyle%20music%20photography&width=640&height=360&seq=td-v37&orientation=landscape",
    duration: 264,
    plays: 660000,
    publishDate: "2026-09-20",
    category: "music",
    author: "音乐盒子",
    description:
      "把那些听过很多遍的老歌，用最简单的方式重新唱一遍。没有复杂的编曲，只有一把吉他和你熟悉的和弦，适合在安静的夜里慢慢听。",
  },
  {
    id: "v38",
    title: "纯音乐歌单：适合学习与工作的背景乐",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20study%20workspace%20with%20an%20open%20book%2C%20headphones%20and%20a%20warm%20cup%20of%20tea%20by%20the%20window%2C%20soft%20daylight%2C%20peaceful%20background%20music%20mood%2C%20minimal%20cozy%20photography&width=640&height=360&seq=td-v38&orientation=landscape",
    duration: 708,
    plays: 410000,
    publishDate: "2026-08-30",
    category: "music",
    author: "音乐盒子",
    description:
      "学习或工作时总觉得安静不下来？这份纯音乐歌单没有歌词、不抢注意力，能帮你稳住节奏。视频附上完整曲目顺序，可以直接当背景音循环。",
  },
  {
    id: "v39",
    title: "滑板入门：新手第一天该练什么",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20person%20learning%20to%20skateboard%20on%20a%20smooth%20urban%20plaza%20at%20golden%20hour%2C%20casual%20sporty%20outfit%2C%20dynamic%20beginner%20stance%2C%20energetic%20lifestyle%20photography%2C%20warm%20light&width=640&height=360&seq=td-v39&orientation=landscape",
    duration: 216,
    plays: 290000,
    publishDate: "2026-09-15",
    category: "sports",
    author: "运动日记",
    description:
      "第一次站上滑板，先别急着做动作。这期从站姿、推板到安全防护讲起，把新手最容易忽略的细节都说清楚了，跟着练第一节课就有感觉。",
  },
  {
    id: "v40",
    title: "家庭健身：不用去健身房也能练全身",
    cover:
      "https://readdy.ai/api/search-image?query=Home%20fitness%20workout%20scene%20in%20a%20bright%20living%20room%20with%20a%20yoga%20mat%20and%20dumbbells%2C%20morning%20light%2C%20healthy%20active%20lifestyle%2C%20clean%20modern%20interior%20photography&width=640&height=360&seq=td-v40&orientation=landscape",
    duration: 468,
    plays: 480000,
    publishDate: "2026-08-29",
    category: "sports",
    author: "运动日记",
    description:
      "没有健身房也能练到全身。这组家庭训练动作对场地零要求，配合简单的节奏和呼吸，二十分钟就能完成一次高效燃脂，适合每天坚持。",
  },
];